import { ObjectType } from '@/@types/graphql-types';
import { TrackingSpecs, createSpecTracker, defineSpec } from '@/libraries/tracking/specTracker';

const specs = {
	// AUTHOR
	clickOnAuthor: defineSpec<{
		property: string;
		useLastRoute: boolean;
	}>()({
		category: 'persons_credit_name',
		action: 'clicked',
		label: 'AUTHOR',
	}),

	clickContentFilter: defineSpec<{
		property: 'articles' | 'lists' | 'other';
	}>()({
		category: 'userinteraction',
		action: 'filter_toggled',
		label: 'content_types',
	}),

	clickOnAuthorLinks: defineSpec<{
		category: 'person_social_media' | 'person_publication';
		property: string;
	}>()({
		action: 'clicked',
		label: 'AUTHOR',
	}),

	// NEWS & LIST
	clickArticleLink: defineSpec<{
		label: 'internal' | 'external';
		property: string;
	}>()({
		category: 'userinteraction',
		action: 'content_clicked',
	}),

	// NEWS ARTICLE
	clickPlayOnTrailer: defineSpec<{
		action: ObjectType;
	}>()({
		category: 'youtube_playing',
		label: 'backdrop',
	}),

	// LIST ARTICLE
	clicksOnTitle: {
		category: 'userinteraction',
		action: 'title_clicked',
		label: 'editorial-lists',
	},

	clickOnReadMore: defineSpec<{
		action: 'expanded' | 'collapsed';
	}>()({
		category: 'content_header',
	}),

	// GUIDE PAGE
	clickGuideItemLink: defineSpec<{
		property: 'editorial-list' | 'news' | 'title';
		label: string;
		value: number;
	}>()({
		category: 'userinteraction',
		action: 'content_clicked',
	}),
} satisfies TrackingSpecs;

export function useEditorialTracking() {
	const trackEditorial = createSpecTracker({ specs });

	return {
		trackEditorial,
	};
}
